module.exports = __webpack_public_path__ + "img/msg_img1.080a92b9.jpg";